import styled from 'styled-components';
import { color, gutter } from '../../styles/mixins';
import { p14 } from '../../styles/typography';

export const Td = styled.td`
  ${p14};
  padding: ${gutter(2)} ${gutter(1)};

  border-bottom: 1px solid ${color('gray30')};
  color: ${color('gray100')};
`;
